




















import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Choices, { Choice } from '@/store/modules/Choices';
import ChoiceViewpointCommonMenu from '@/components/common/ChoiceViewpointCommonMenu.vue'
import Decisions from '@/store/modules/Decisions';
import Apps from '@/store/modules/Apps';

const appsModule = getModule(Apps);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);

@Component({
    components: {
        ChoiceViewpointCommonMenu,
    },
    directives: {},
})
export default class ChioceSelectCommon extends Vue {

    private loading = false;
    
    @Prop({ default: false, type: Boolean })
    appEmbed: boolean;
    
    @Prop({ default: false, type: Boolean})
    isDialog!: false;

    @Prop({ default: false, type: Boolean})
    isChoiceCard!: false;

    @Prop({ default: false, type: Boolean})
    isChoiceSubmitter!: false;
    
    get selectedChoice() {
        return choicesModule.selectedChoice || null;
    }

    get choiceSelectionMenu() {
        return appsModule.choiceSelectionMenu;
    }

    get isOwnerOrAdmin() {
        return decisionsModule.isAdminOrOwner;
    }
    
    set selectedChoice(choice: Choice) {
        if(choice != null) {
            choicesModule.selectChoice(choice.id);
        }
    }

    get choicesList() {
        return choicesModule.choicesList;
    }
    
    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }
    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

}
